import { render, staticRenderFns } from "./DiffView.vue?vue&type=template&id=30ba4538&scoped=true"
import script from "./DiffView.vue?vue&type=script&lang=js"
export * from "./DiffView.vue?vue&type=script&lang=js"
import style0 from "./DiffView.vue?vue&type=style&index=0&id=30ba4538&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba4538",
  null
  
)

export default component.exports